export const endPoints = {
  UZUM_CONFIG: "v1/uzum/config",
  UZUM_HOUSES: "v1/uzum/config/house",
  CREATE_SERVICE: "v1/uzum/config/service"
}